import { AppleBoldIcon, CheckCircleBoldIcon } from '@src/svg';
import AppleLogin from 'react-apple-login';
import { APPLE_CLIENT_ID } from '@utils/constants';
import React, { FC } from 'react';
import { newTargetUrl } from '@component/SSO/buttons/GoogleSignInButton';

type AppleSignInButtonProps = {
  type?: 'attach' | 'basic';
  activated?: boolean;
};

export const AppleSignInButton: FC<AppleSignInButtonProps> = ({
  type = 'basic',
  activated = false,
}) => {
  return (
    <AppleLogin
      clientId={APPLE_CLIENT_ID}
      redirectURI={`${newTargetUrl}/apple/callback`}
      scope="name email"
      responseType="code"
      state={type}
      responseMode="query"
      usePopup={false}
      render={(props) => (
        <button
          onClick={props.onClick}
          className="social_button"
          disabled={props.disabled || (activated && type !== 'basic')}
          aria-label="Sign in with Apple"
        >
          <AppleBoldIcon />
          {type !== 'attach'
            ? ''
            : activated
              ? 'Apple SSO Activated'
              : 'Setup Apple SSO'}
          {type === 'basic' && 'Sign in with Apple'}
          {activated && type !== 'basic' && (
            <span className="sso-activated-icon">
              <CheckCircleBoldIcon width={24} height={24} />
            </span>
          )}
        </button>
      )}
    />
  );
};
